<template lang='pug'>
    div
        div.fullwidth(v-if="$route.params.lang == 'en'")
            div.title-container
                h1.product-title Electrical PD Sensors
                //- h2.notopmargin BSS offers a range of PD sensors suitable for measurements of partial discharges at cables, MV switchgears and transformers.

            router-link.section(to="/en/products/electricalpdsensors/zm3")
                .column-container
                    .column.flexgrow
                        .producttitle ZM3
                        .subtitle PD Coupling Device with 3 Input Channels
                        ul
                            li Bandwidth: 100 kHz … 30 MHz
                            li For three-phase electrical PD measurements at MV switchgears
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/ZM3.webp')
                            img( src='@/assets/photos/product_shots/ZM3.png', width="100%", alt='ZM3', title='ZM3')

            router-link.section(to="/en/products/electricalpdsensors/bs-pd")
                .column-container
                    .column.flexgrow
                        .producttitle BS-PD
                        .subtitle PD & Bushing Monitoring Sensor for Test Taps
                        ul
                            li Various types available for all capacitive graded bushing types
                            li Integrated measuring impedance Z#[sub m]
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/BS-PD.webp')
                            img( src='@/assets/photos/BS-PD.png' height="100%", alt='BS-PD', title='BD-PD')

            router-link.section(to="/en/products/electricalpdsensors/hfct-50")
                .column-container
                    .column.flexgrow
                        .producttitle HFCT-50
                        .subtitle Split-Core HFCT for Electrical PD Measurement
                        ul
                            li Bandwidth: 1 MHz … 52 MHz
                            li Up to 50 mm cables
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/HFCT-50.webp')
                            img( src='@/assets/photos/HFCT-50.png' height="100%", alt='HFCT-50', title='HFCT-50')

        div.fullwidth(v-if="$route.params.lang == 'de'")
            div.title-container
                h1.product-title Elektrische Teilentladungssensoren
                //- h2.notopmargin Die BSS bietet TE-Sensorik für Kabel, Mittelspannungsschaltanlagen und Transformatoren an.

            router-link.section(to="/de/products/electricalpdsensors/zm3")
                .column-container
                    .column.flexgrow
                        .producttitle ZM3
                        .subtitle TE-Ankoppelvierpol mit 3 Eingangskanälen
                        ul
                            li Bandbreite: 100 kHz … 30 MHz
                            li Für dreiphasige elektrische TE-Messung an Mittelspannungsschaltanlagen
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/ZM3.webp')
                            img( src='@/assets/photos/product_shots/ZM3.png', width="100%", alt='ZM3', title='ZM3')

            router-link.section(to="/de/products/electricalpdsensors/bs-pd")
                .column-container
                    .column.flexgrow
                        .producttitle BS-PD
                        .subtitle TE- und Durchführungs-Monitoring-Sensor für Messanschlüsse
                        ul
                            li Für kapazitiv gesteuerte Durchführungen verschiedenen Types
                            li Integrierte Messimpedanz (AKV)

                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/BS-PD.webp')
                            img( src='@/assets/photos/BS-PD.png' height="100%", alt='BS-PD', title='BD-PD')

            router-link.section(to="/de/products/electricalpdsensors/hfct-50")
                .column-container
                    .column.flexgrow
                        .producttitle HFCT-50
                        .subtitle Stromwandler mit Split-Core-Design für die elektrische TE-Messung
                        ul
                            li Bandbreite: 1 MHz … 52 MHz
                            li Bis zu 50 mm Kabeldurchmesser

                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/HFCT-50.webp')
                            img( src='@/assets/photos/HFCT-50.png' height="100%", alt='HFCT-50', title='HFCT-50')

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | TE-Sensoren",
            description: "Teilentladungs(TE)-Sensoren",
        },
        en: {
            title: "BSS | PD Sensors",
            description: "Partial Discharge (PD) Sensors",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/product_overview.sass'
</style>